<div class="p-px-24 d-flex flex-column">
  <div class="d-flex justify-content-end pb-px-12 cursor-pointer">
    <svg-icon
      (click)="onDialogClose()"
      src="/assets/icons/close-modal-primary.svg"
class="cursor-pointer"
    ></svg-icon>
  </div>
  <mat-tab-group
    mat-stretch-tabs="{{ false }}"
    mat-align-tabs="start"
    color="primary"

  >
    <mat-tab label="Details">
      @if(!loading) {
        <div class="py-px-24 d-flex flex-column">
          <app-user
            [text]="candidat?.fullname"
            [imageSrc]="candidat?.photo"
          ></app-user>
          <app-text-separator
            innerClass="my-px-24"
            text="Details"
          ></app-text-separator>
          <div class="d-flex">
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Fonction</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.typePosteDto?.name || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Années d’expérience</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.yearsOfExperiances || 'N/A' }}</div>
              </div>

            <div class="d-flex flex-column">
              <div class="fs-13 fw-3 text-neutral-dark">
                Département de résidence
              </div>
              <div class="fs-16 fw-4 text-neutral-dark">
                {{ candidat?.adresseCandidatDto?.additionalAdress }}
              </div>
            </div>

            </div>
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Age</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.age || 'N/A' }}</div>
              </div>
                <div class="d-flex flex-column">
                  <div class="fs-13 fw-3 text-neutral-dark">Inscrit(e) sur la plateforme depuis</div>
                  <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.inscriptionYears || 'N/A' }}</div>
                </div>

            </div>
          </div>
          <app-text-separator
            innerClass="my-px-24"
            text="Évaluations et missions"
          ></app-text-separator>
          <div class="d-flex gap-2 justify-content-between">
            <div class="d-flex flex-column col-3">
              <div class="d-flex gap-2 align-items-center">
                <div class="fw-4 fs-24 text-neutral-dark">{{candidat.rating}}</div>
                <app-rating
                  [rating]="candidat.rating"
                  [readOnly]="true"
                  [width]="14"
                  [height]="14"
                ></app-rating>
              </div>
              <div class="text-neutral-dark fs-14 mt-1">
                / {{candidat?.ratingCount || 0}} Évaluation(s)
              </div>
              <div class="fs-13 fw-3 text-neutral-dark">Évaluation moyenne</div>
            </div>
            <div class="d-flex flex-column col-3">
              <div class="fw-4 fs-24 text-neutral-dark">{{candidat?.terminatedMission || 0}}</div>
              <div class="fs-13 fw-3 text-neutral-dark">
                Total des missions effectuées.
              </div>
            </div>
            <div class="d-flex flex-column col-4">
              <div class="fw-4 fs-24 text-neutral-dark">{{candidat?.collaborationCount || 0}}</div>
              <div class="fs-13 fw-3 text-neutral-dark">
                Collaborations précédentes avec cet établissement.
              </div>
            </div>
          </div>
        </div>
      } @else {
        <app-loader ></app-loader>
      }
    </mat-tab>

    <mat-tab label="Documents">
      <ng-container *ngIf="!!candidat">
        <ng-container *ngFor="let el of getOrderedDocs()">
          <app-text-separator text="{{el?.category}}" innerClass="mt-px-32 mb-px-32"></app-text-separator>
          <div class="d-flex  flex-column gap-4">
            <ng-container *ngFor="let doc of el?.docs">
              <span class="cursor-pointer" (click)="download(doc.attr)">{{ doc.label }}</span>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </mat-tab>

  <mat-tab label="Planning">
    <div *ngIf="!calenderLoader">
      <app-calendar
        [actionBtn]="true"
        [data]="randomData"
        [events]="events"
        [user]="user"
        [isCandidat]="true"
        [disponibilityDays]="disponibilityDays"
      ></app-calendar>
    </div>
  </mat-tab>
  </mat-tab-group>

</div>
